import {
    Button,
    CurrencyInput,
    FormError,
    FormGroup,
    FormLabel,
    Modal,
    Option,
    Select
} from "@components";
import { toast } from "@components/toast/Toast";
import { useState } from "react";
import { useForm } from 'react-hook-form';
import { markPaymentRequestPaid } from "@api";
import { formatAmount } from "@utils";

const MarkAsPaid = ({ isOpen, onClose, onComplete, paymentRequestId, amountRequested }) => {

  const [submitting, setSubmitting] = useState(false);

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      amount: amountRequested,
      subType: "Bacs"
    }
  });


  const onSubmit = async (formData) => {
    setSubmitting(true);
    await markPaymentRequestPaid(paymentRequestId, formData.amount, formData.subType);
    setSubmitting(false);
    toast({ description: `Request for ${formatAmount(formData.amount)} marked as paid` });
    onComplete();
    onChange();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Mark as paid">
      <form className="p-5" onSubmit={handleSubmit(onSubmit)}>
        <FormGroup>
          <FormLabel>Amount received</FormLabel>
          <CurrencyInput
            name="amount"
            control={control}
            min={0.01}
            max={amountRequested}
            errors={errors.amount}
          />
          <FormError name="amount" errors={errors} />
        </FormGroup>
        <FormGroup>
          <FormLabel>Payment method</FormLabel>
          <Select
            name="subType"
            control={control}
          >
            <Option value="Bacs">BACS</Option>
            <Option value="Cash">Cash</Option>
            <Option value="Cheque">Cheque</Option>
            <Option value="Pdq">PDQ</Option>
          </Select>
        </FormGroup>
        <Button submitting={submitting} className="ml-auto" color="primary" type="submit">Mark as paid</Button>
      </form>
    </Modal>
  );
}

export default MarkAsPaid;